<template>
  <!-- 第二步：申报项目基本信息 -->
  <div class="productInfo">
    <el-dialog :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <el-dialog
        title="添加产品"
        :visible.sync="dialogVisible"
        width="60%"
        :before-close="handleClose"
    >
      <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="180px"
          class="demo-form"
      >
        <div class="">
          <el-form-item label="产品及解决方案名称" prop="productAndSolutionName">
            <el-input show-word-limit v-model="form.productAndSolutionName" style="width:100%"></el-input>
          </el-form-item>

        </div>
        <div class="flex">
          <el-form-item label="面向产业" prop="industryOriented">
            <el-select v-model="form.industryOriented" placeholder="请选择" clearable :style="`width: ${widthInput}px`" multiple>
              <el-option
                  v-for="item in sectorList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="应用场景" prop="applicationScene">
            <el-select v-model="form.applicationScene" placeholder="请选择" clearable :style="`width: ${widthInput}px`" multiple>
              <el-option
                  v-for="item in caseList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <template v-if="form.industryOriented && form.industryOriented.length > 0 && form.industryOriented.includes('其他')">
          <div class="" >
            <el-form-item label="产业名称" prop="industryName">
              <el-input placeholder="请输入产业名称"
                        v-model="form.industryName" style="width:100%"></el-input>
            </el-form-item>

          </div>
        </template>
        <div class="flex">
          <el-form-item label="主要服务的重点行业" prop="primaryServicesKeyIndustry">
            <el-select v-model="form.primaryServicesKeyIndustry" placeholder="请选择" clearable :style="`width: ${widthInput}px`" multiple>
              <el-option
                  v-for="item in industryList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="价格区间（单位：万元）" prop="priceRange">
            <el-select v-model="form.priceRange" placeholder="请选择" clearable :style="`width: ${widthInput}px`">
              <el-option
                  v-for="item in priceList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="flex">
          <el-form-item label="实施周期（单位：周）" prop="implementationCycle">
            <el-select v-model="form.implementationCycle" placeholder="请选择" clearable :style="`width: ${widthInput}px`">
              <el-option
                  v-for="item in cycleList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="">
          <el-form-item label="产品及解决方案简介" prop="briefIntroduction">
            <el-input placeholder="简要介绍产品及解决方案解决的痛点问题，其核心技术及产品优势（包括与传统解决方案、与同行的对比分析），其所应用的客户等。300字内"
                      type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 2, maxRows: 10}" v-model="form.briefIntroduction" style="width:100%"></el-input>
          </el-form-item>

        </div>
        <div class="">
          <el-form-item label="应用价值" prop="applicationValue">
            <el-input placeholder="对比使用前，会为客户带来什么新价值、新效果等，例如成本、生产效率、质量、能耗等量化指标（可进行应用前后对比，例如OEE提升10%）,或者形成了新业务、新模式、新业态等。200字内"
                      type="textarea" maxlength="200" show-word-limit :autosize="{ minRows: 2, maxRows: 10}" v-model="form.applicationValue" style="width:100%"></el-input>
          </el-form-item>

        </div>


        <div class="flex">
          <el-form-item  label="产品及解决方案图片" prop="attachNamePlan" style="width:100%">
            <el-upload
                class="avatar-uploader"
                action="/service-center/api/v1/upload/file/single"
                :file-list="fileList"
                :headers="headers"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :before-upload="beforeAvatarUpload"
                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PBG,.GIF,.BMP"
                :on-remove="handleRemoveFile"
                :on-error="handleFileError"
                :on-success="handleFileSuccess">
              <i class="el-icon-plus"></i>
            </el-upload>
            <span class="red" v-if="fileList.length == 0">
              *未选择任何文件 注意：支持多张图片，格式：横图，16:9，png、jpg等图片格式，不超过2MB，清晰。
            </span>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')"
        >确 定</el-button
        >
      </span>
    </el-dialog>
    <!--    提示语-->
    <div class="" style="font-size: 13px;margin-bottom: 10px">
      <span style="color: red;">*</span><span style="margin-left: 5px;">产品及解决方案填写（不少于2个）</span>
    </div>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column
          v-for="(item, index) in headList"
          :key="index"
          :prop="item.value"
          :label="item.label"
          :width="item.width"
          :align="align"
      >
      </el-table-column>
      <el-table-column prop="indexCompany" label="操作" align="center" width="140" v-if="!disabled">
        <template slot-scope="scope">
          <div class="flex">
            <el-button v-if="!disabled"  type="primary" size="mini" @click="editIndex(scope.row, scope.$index)" :disabled="disabled">编辑</el-button>
            <el-button v-if="!disabled" type="danger" size="mini" @click="deleteIndex(scope)" :disabled="disabled">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;margin-top: 20px;">
      <el-button v-if="!disabled" type="primary" size="mini" @click="addIndex" :disabled="disabled">新增</el-button>
      <!-- <el-button
        v-show="tableData.length > 1"
        type="danger"
        @click="deleteIndex"
        :disabled="disabled"
      >删除指标</el-button>-->
    </div>
  </div>
</template>

<script>
import {saveServiceProviderThirdInfo, getServiceProviderThirdInfo, getIndexDictionaryData} from "../../utils/interface";
import {addProductConsult} from "../../utils/product";
/* 是否是正数 */
const straight = (rule, value, callback) => {
  // console.log(rule, value);
  if (!value) {
    callback(new Error(rule.message));
  }
  let reg = /^\d+(?=\.{0,1}\d+$|$)/;
  if (!reg.test(value)) {
    callback(new Error());
  }
  callback();
};
const form = () => {
  return {
    industryName:'',
    attachNamePlan:'',
    profile:'',
    speciality:'',
    realName:'',
    title:'',
    education:'',
    major:'',
    attachPlan:[],
  };
};
const rules = () => {
  return {
    productAndSolutionName: [
      { required: true, message: "请输入产品及解决方案名称", trigger: "blur" }
    ],
    industryOriented: [
      { required: true, message: "请选择面向产业", trigger: "blur" }
    ],
    primaryServicesKeyIndustry: [
      { required: true, message: "请选择主要服务的重点行业", trigger: "blur" }
    ],
    implementationCycle: [
      { required: true, message: "请选择实施周期", trigger: "blur" }
    ],
    industryName: [{ required: true, message: "请输入其他产业名称", trigger: "blur" }],
    applicationScene: [{ required: true, message: "请选择应用场景", trigger: "blur" }],
    priceRange: [
      { required: true, message: "请选择价格区间", trigger: "blur" }
    ],
    briefIntroduction: [
      { required: true, message: "请输入产品及解决方案简介", trigger: "change" }
    ],
    applicationValue: [
      { required: true, message: "请输入应用价值", trigger: "blur" }
    ],
    attachNamePlan: [
      { required: true, message: "请上传产品及解决方案图片", trigger: "blur" }
    ]
  };
};
export default {
  name: "",
  components: {},
  props: {
    uuid: String
  },
  data() {
    return {
      headList: [
        { label: "产品及解决方案", value: "productAndSolutionName" },
        { label: "面向产业", value: "industryOriented" },
        { label: "应用场景", value: "applicationScene", },
      ],
      align: {
        type: String,
        default: "center"
      },
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token") //	可以是授权凭证用的参数值
      },
      widthInput: 300,
      dialogVisible: false,
      form: form(),
      industryList: [],
      // 助理工程师、中级工程师、副高级工程师、正高级工程师
      sectorList: [],
      caseList:[],
      // 0-5万、5-10万、10-15万、15-20万、20-50万、50万以上
      priceList: [
        {
          name: "0-5万",
          value: "0-5万"
        },
        {
          name: "5-10万",
          value: "5-10万"
        },{
          name: "10-15万",
          value: "10-15万"
        },{
          name: "15-20万",
          value: "15-20万"
        },{
          name: "20-50万",
          value: "20-50万"
        },{
          name: "50万以上",
          value: "50万以上"
        }],
      cycleList: [
        {
          name: "0-4周",
          value: "0-4周"
        },
        {
          name: "4-8周",
          value: "4-8周"
        },
        {
          name: "8-12周",
          value: "8-12周"
        },
        {
          name: "12-30周",
          value: "12-30周"
        },
        {
          name: "30-60周",
          value: "30-60周"
        },
        {
          name: "60周以上",
          value: "60周以上"
        }
      ],
      dialogImageUrl: '',
      imgDialogVisible: false,
      fileList: [],
      editIndexRow: -1, // 当前编辑行的索引
      rules: rules(),
      indexForm: {
        cost: "", // 降低企业成本
        defective: "", // 降低不良品率
        efficient: "", // 提高生产运营效率
        utilization: "" // 提高能源利用率
      }, // 4个指标，至少填2个
      tableData: [],
      disabled: false,
      showFile: false
    };
  },
  watch: {
    "form.buildDate"(val) {
      if (val) {
        this.form.startDate = val[0];
        this.form.endDate = val[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      // console.log(val, this.form)
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.getCompanyType();
    if (this.$route.query.uuid) {
      console.log('第两步')
      this.getServiceProviderThirdInfo(this.$route.query.uuid);
    }
  },
  methods: {
    /* 获取企业性质、企业规模、第一产业下行业、第二产业下行业、第三产业下行业 */
    getCompanyType() {

      getIndexDictionaryData({
        groupCode: "service_provider_industry"
      }).then(res => {
        this.industryList = res;
      });
      getIndexDictionaryData({
        groupCode: "service_provider_sector"
      }).then(res => {
        this.sectorList = res;
      });
      getIndexDictionaryData({
        groupCode: "service_provider_case"
      }).then(res => {
        this.caseList = res;
      });
    },
    handleClose() {
      this.form=form();
      this.editIndexRow = -1; // 重置编辑行索引
      this.dialogVisible = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.fileList && this.fileList.length > 0){
            this.form.attachPlan = [];
            this.fileList.forEach(items => {
              this.form.attachPlan.push({
                path: items.url || items.path,
                name: items.name,
              });
            })
          }
          this.handleSubmitForm();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSubmitForm() {
      this.form = {
        ...this.form,
        primaryServicesKeyIndustry:this.form.primaryServicesKeyIndustry?this.form.primaryServicesKeyIndustry.join(','):'',
        applicationScene: this.form.applicationScene.join(','),
        industryOriented:this.form.industryOriented.join(',')
      }
      if (this.editIndexRow === -1) {
        // 新增模式
        this.tableData.push({ ...this.form });
      } else {
        // 编辑模式
        this.$set(this.tableData, this.editIndexRow, { ...this.form });
      }
      this.handleClose();
    },
    // 模板附件
    handleFileSuccess(res, file) {
      this.fileList.push(res);
      this.form.attachNamePlan = res.name;
    },
    handleRemoveFile(file, fileList) {
      this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },

    handleFileError(err, file, fileList) {
      this.$message.error(err);
    },
    /* 新增指标 */
    addIndex() {
      // this.tableData.push({
      //   indexName: "",
      //   indexValue: "",
      //   indexCompany: ""
      // });
      this.form = form();
      this.fileList = [];
      this.editIndexRow = -1; // 重置编辑行索引
      this.dialogVisible = true;
    },
    // 新增编辑方法
    editIndex(row, index) {
      this.form = {
        ...row,
        primaryServicesKeyIndustry:row.primaryServicesKeyIndustry?row.primaryServicesKeyIndustry.split(','):'',
        applicationScene: row.applicationScene.split(','),
        industryOriented:row.industryOriented.split(',')
      }
      this.fileList = row.attachPlan?row.attachPlan.map(items => {
        return {
          ...items,
          url: items.path || items.url,
        }
      }) : [];
      // this.form = { ...row }; // 复制当前行数据到表单
      this.editIndexRow = index; // 记录编辑行索引
      this.dialogVisible = true;
    },
    /* 删除指标 */
    deleteIndex(row) {
      // if (this.tableData.length == 1) {
      //   this.$message.warning("请至少保留一条指标！");
      //   return;
      // }
      this.$confirm("确认删除该条吗！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.tableData.splice(row.$index, 1);
      });
    },
    /* 获取第二步详情 */
    getServiceProviderThirdInfo(uuid) {
      getServiceProviderThirdInfo({unitUuid: uuid}).then(res => {
        if (res.success && res.data.length > 0) {
          this.form = res.data;

          this.form.buildDate = [this.form.startDate, this.form.endDate];
          this.disabled =
              this.$route.query.status == "1" ||
              this.$route.query.status == "4"
                  ? false
                  : true;
          this.tableData = res.data;
          // this.uuid = res.data.uuid;
          this.showFile = true;
        } else {
          this.form = form();
          this.indexForm = {
            cost: "",
            defective: "",
            efficient: "",
            utilization: ""
          };
          // this.tableData = [
          //   { indexName: "", indexValue: "", indexCompany: "" }
          // ];
        }
      });
    },
    /* 第二步保存 */
    save() {
      // console.log('第二步保存')
      const sum = this.tableData.length;
      if (sum < 2) {
        this.$message({
          message: "产品及解决方案填写不少于2个！",
          type: "warning"
        });
        return;
      }
      const list = this.tableData.map(item=>{
        return {
          ...item,
          unitUuid:this.$route.query.uuid || this.uuid,
        }
      });
      saveServiceProviderThirdInfo(list).then(res => {
        if (res.success) {
          this.$message({
            message: res.message,
            type: "success"
          });
          // this.uuid = res.data.uuid;
          this.$parent.activeStep++;
        } else {
          console.log('产品及解决方案填写（不少于2个）',res);
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch(err => {
        console.log(err);
        this.$message({
          message: "系统异常，请重试或联系管理员！",
          type: "error"
        });
      });
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      let isLt10M = file.size / 1024 / 1024 < 10;
      let fileNameLength = file.name.length <= 100;
      // this.fileName = file.name
      let fileName = file.name.lastIndexOf(".");
      const fileNameLen = file.name.length;
      const fileTypeName = file.name.substring(fileName, fileNameLen);
      if (!isLt10M) {
        this.$alert("文件大小不能超过10M", "提示", {
          confirmButtonText: "确定"
        });
      } else if (!fileNameLength) {
        this.$alert("文件名（包含后缀名）的最大长度不能超过100个字符", "提示", {
          confirmButtonText: "确定"
        });
      }
      return isLt10M && fileNameLength;
    },
    handleAvatarSuccess(res) {
      if (res) {
        this.form.file = res.url;
        this.form.fileName = res.fileName;
        this.showFile = false;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success"
        });
        // console.log(this.form)
      }
    },
    removeFile() {
      this.form.file = "";
      this.form.fileName = "";
      console.log(this.form);
    },
    /* 下载文件 */
    downloadFile(url, name) {
      fetch(url).then(res => {
        res.blob().then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = name;
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";

.productInfo {
  min-height: 300px;
  margin-bottom: 35px;
  border-radius: 12px;

  .w350 {
    width: 350px;
  }

  .downFile {
    display: inline-flex;
    height: 40px;
    align-items: center;
    box-sizing: border-box;
    font-size: 14px;
    color: @basic-colors;
    cursor: pointer;
    text-decoration: underline;
  }

  .form-wrap {
    padding: 10px 20px;
    .bs();

    p {
      font-size: 14px;
      color: #888888;
      line-height: 1.7;
      margin-bottom: 40px;
    }

    .iploadInput {
      display: inline-flex;
      /deep/ .el-upload {
        align-self: start;
      }
    }

    .form-title {
      font-size: 14px;
      font-weight: bold;
      margin: 0 0 30px 0px;
      position: relative;
      color: #535353;

      &::before {
        position: absolute;
        content: "";
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #000;
        top: 50%;
        left: -8px;
        transform: translateY(-50%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/providerApply/productInfo.vue